import { createStore, combineReducers, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import authReducer from '../reducers/authReducer';
import UserConfig from '../reducers/configReduser';
import UserprofileReducer from '../reducers/UserprofileReducer';
import breadCrumbReducer from '../reducers/breadCrumbReducer';
import dashboardReducer from '../reducers/dashboardReducer';
import batchPayoutsReducer from '../reducers/batchPayoutsReducer';
import PayeeReducer from '../reducers/payeesReducer';
import vaultsAccordionReducer from '../reducers/vaultAccordionReducer';
const persistConfig = {
    key: "root",
    storage,
    whitelist: ["auth"]
}
const rootReducer = combineReducers({
    oidc: authReducer,
    userConfig: UserConfig,
    userProfile: UserprofileReducer,
    breadCrumb:breadCrumbReducer,
    dashboardReducer : dashboardReducer,
    batchPayouts : batchPayoutsReducer,
    payeesReducer:PayeeReducer,
    vaultsAccordion:vaultsAccordionReducer
});
const reducer = persistReducer(persistConfig, rootReducer)
const store = createStore(
    reducer,
    composeWithDevTools(applyMiddleware(thunk)),
);
const persistor = persistStore(store);

export { store, persistor }